import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { useFnol } from '../../context';

const FnolRecievedView = () => {
  useEffect(() => {
    window.parent.postMessage(
      {
        type: 'navigate',
      },
      '*'
    );
  }, []);

  const { fnolTemplate } = useFnol();

  return (
    <ReactMarkdown linkTarget='_blank' children={fnolTemplate.outroMarkdown} />
  );
};

export default FnolRecievedView;
